<template>
  <div class="qdjl-div">
    <div class="qdjl-top">
      <img src="@images/grzx/qdjl-top.png" style="width: 100%" />
      <div class="qdjl-top-v">
        <div class="qdjf-top-m"><img src="@images/grzx/jb.png" />签到积分</div>
        <div class="qdjf-top-v">{{ qdjf }}</div>
      </div>
    </div>
    <div class="rl-v">
      <div class="rl-top">
        <img src="@images/grzx/rl-top.png" />
        <img src="@images/grzx/rl-top.png" />
      </div>
      <JCalendar :dataSource="signData" :isFullCalendar="false" @dateChange="dataChange" />
    </div>
    <div class="rl-btn">本月已签到{{ total }}天</div>
  </div>
</template>

<script>
import JCalendar from '@/views/common/j-calendar.vue'
import { getAction } from '@/api/manage'
export default {
  components: {
    JCalendar,
  },
  data() {
    return {
      signData: [],
      qdjf: '',
      total: '',
    }
  },
  created(e) {
    this.initData()
  },
  methods: {
    initData(e) {
      this.getJfData()
      const date = new Date()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      let newDate = `${date.getFullYear()}-${month}`
      this.getQdData(newDate)
    },
    getJfData() {
      let url = '/zhshj/xtjfgllsjl/qdjf'
      getAction(url)
        .then((res) => {
          if (res.success) {
            let obj = res.result
            this.qdjf = obj
          }
        })
        .catch((error) => {})
    },
    getQdData(searchDate) {
      let url = '/zhshj/xtjfgllsjl/qdjl'
      let params = { searchDate }
      getAction(url, params)
        .then((res) => {
          if (res.success) {
            let list = res.result
            this.signData = list.map((obj) => obj.dateStr)
            this.total = this.signData.length
          }
        })
        .catch((error) => {})
    },
    dataChange(e) {
      let newDate = this.formatMonth(e)
      this.getQdData(newDate)
    },
    formatMonth(dateString) {
      const date = new Date(dateString)
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      return `${date.getFullYear()}-${month}`
    },
  },
}
</script>

<style lang="less" scoped>
.qdjl-div {
  background-image: linear-gradient(180deg, #ff522f 0%, #ff6f36 100%);
  padding-bottom: 10px;
  min-height: 100vh;
}

.qdjl-top {
  position: relative;

  .qdjl-top-v {
    position: absolute;
    left: 22px;
    top: 49px;
    color: #fff;

    .qdjf-top-m {
      display: flex;
      align-items: center;
      font-size: 14px;
      img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
      }
    }

    .qdjf-top-v {
      padding-left: 26px;
      font-size: 28px;
    }
  }
}

.rl-v {
  position: relative;
  margin: -54px 10px 0;
  height: auto;
  background: #ffffff;
  box-shadow: 0 15px 0 0 #ff5831;
  border-radius: 20px;
  z-index: 1;
  padding-bottom: 12px;
  padding-top: 30px;

  .rl-top {
    display: flex;
    justify-content: space-around;
    position: absolute;
    top: -20px;
    width: 100%;
    img {
      width: 22px;
      height: 54px;
    }
  }
}

.rl-btn {
  margin: 34px 10px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  background: #ff5831;
  border-radius: 45px;
  margin-top: 30px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
}
</style>